import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdviserCitizenComponent } from './adviser-citizen.component';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FuseSharedModule } from '@fuse/shared.module';

const routes = [
  {
      path     : 'auth/adviser-citizen-form',
      component: AdviserCitizenComponent
  },
];

@NgModule({
  declarations: [AdviserCitizenComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,

    FuseSharedModule
  ],
  exports: [
    AdviserCitizenComponent
  ]
})
export class AdviserCitizenModule { }
